function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDirection, useLocale, usePrefixCls } from '@byte-design/config';
import { useCombineCallback, useRefCallback, useRefFunction } from '@bydesign-ui/hooks';
import { classnames, pick, shallowEqual } from '@bydesign-ui/utils';
import { CloseOne } from '../../common/icons';
import { INPUT_COMMON_ATTRS } from '../../units/input-wrapper/const';
import { Tag } from '../tag';
import { Tooltip } from '../tooltip';
export function MultipleInput(props) {
  var _a;

  var locale = useLocale('input.placeholder');

  var value = props.value,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onChange = props.onChange,
      maxHeight = props.maxHeight,
      className = props.className,
      onKeyUp = props.onKeyUp,
      onKeyDown = props.onKeyDown,
      onKeyPress = props.onKeyPress,
      onPressEnter = props.onPressEnter,
      onMouseEnter = props.onMouseEnter,
      onValueChange = props.onValueChange,
      onMouseLeave = props.onMouseLeave,
      onKeywordChange = props.onKeywordChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      style = props.style,
      width = props.width,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? false : _props$clearable,
      _props$tooltip = props.tooltip,
      tooltip = _props$tooltip === void 0 ? false : _props$tooltip,
      _props$onFilter = props.onFilter,
      onFilter = _props$onFilter === void 0 ? function () {
    return true;
  } : _props$onFilter,
      extra = _objectWithoutProperties(props, ["value", "onFocus", "onBlur", "onChange", "maxHeight", "className", "onKeyUp", "onKeyDown", "onKeyPress", "onPressEnter", "onMouseEnter", "onValueChange", "onMouseLeave", "onKeywordChange", "size", "style", "width", "disabled", "clearable", "tooltip", "onFilter"]);

  var rtl = useDirection() === 'rtl';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hover = _useState4[0],
      setHover = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      keyword = _useState6[0],
      setKeyword = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      userValue = _useState8[0],
      setUserValue = _useState8[1];

  var multiRef = useRef(null);
  var handleFilter = useRefFunction(onFilter);
  var handleKeywordChange = useRefCallback(onKeywordChange);
  var onChangeCombine = useCombineCallback(onChange, onValueChange);
  var handleMouseEnter = useCombineCallback(function () {
    return setHover(true);
  }, onMouseEnter);
  var handleMouseLeave = useCombineCallback(function () {
    return setHover(false);
  }, onMouseLeave);
  var handleChange = useCallback(function (e) {
    setKeyword(e.target.value);
    handleKeywordChange(e.target.value);
  }, []);
  var handleFocus = useCallback(function () {
    if (multiRef.current && !disabled) {
      setFocus(true);
      multiRef.current.focus();
    }
  }, [disabled]);
  var addTag = useCallback(function (text) {
    var newValue = [].concat(_toConsumableArray(userValue), [text]);

    if (handleFilter(text, userValue) && text) {
      setKeyword('');
      setUserValue(newValue);
      onChangeCombine(newValue);
    }
  }, [userValue]);
  var handleBlur = useCallback(function (e) {
    var text = e.currentTarget.value;
    addTag(text);
    setFocus(false);
    onBlur && onBlur(e);
  }, [addTag, onBlur]);
  var handleKeyDown = useCallback(function (e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onKeyDown && onKeyDown(e);
    var text = e.currentTarget.value;

    if (e.keyCode === 13) {
      e.preventDefault();
      addTag(text);
      onPressEnter && onPressEnter(e);
    }
  }, [addTag]);
  var handleClear = useCallback(function (e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    setKeyword('');
    setUserValue([]);
    onChangeCombine([]);
  }, []);
  var handleClose = useCallback(function (index) {
    var newValue = userValue.slice(0, index).concat(userValue.slice(index + 1));
    setUserValue(newValue);
    onChangeCombine(newValue);
  }, [userValue]);
  var panelCls = classnames(usePrefixCls('multiple-input-panel', {
    size: size,
    focus: focus,
    disabled: disabled,
    rtl: rtl
  }), className);
  var contentCls = usePrefixCls('multiple-input-content');
  var clearCls = usePrefixCls('multiple-input-close-icon');
  var showClearIcon = hover && !disabled && clearable;
  var valueCls = usePrefixCls('multiple-input-value', {
    clear: showClearIcon
  });

  var _pick = pick(extra, INPUT_COMMON_ATTRS),
      _pick2 = _slicedToArray(_pick, 2),
      inputAttrs = _pick2[0],
      divAttrs = _pick2[1];

  var tooltipProps = _objectSpread(_objectSpread({
    lazyInit: true,
    placement: 'top-start'
  }, _typeof(tooltip) === 'object' ? tooltip : {}), {}, {
    className: usePrefixCls('multiple-input-tag-tooltip')
  });

  useEffect(function () {
    value && !shallowEqual(value, userValue) && setUserValue(value);
  }, [value]);
  return React.createElement("div", Object.assign({}, divAttrs, {
    className: panelCls,
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: width !== null && width !== void 0 ? width : style === null || style === void 0 ? void 0 : style.width
    }),
    onClick: handleFocus,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }), showClearIcon && React.createElement(CloseOne, {
    theme: "filled",
    className: clearCls,
    onClick: handleClear
  }), React.createElement("div", {
    className: contentCls,
    style: {
      maxHeight: maxHeight
    }
  }, userValue.map(function (item, index) {
    return React.createElement(Tag, {
      fill: true,
      key: "".concat(item).concat(index.toString()),
      size: size,
      closeable: !disabled,
      onClose: function onClose() {
        return handleClose(index);
      }
    }, tooltip ? React.createElement(Tooltip, Object.assign({}, tooltipProps, {
      content: item
    }), item) : item);
  }), React.createElement("input", Object.assign({}, inputAttrs, {
    ref: multiRef,
    value: keyword,
    disabled: disabled,
    className: valueCls,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onKeyUp: onKeyUp,
    onKeyPress: onKeyPress,
    onFocus: onFocus,
    onBlur: handleBlur,
    placeholder: (_a = inputAttrs.placeholder) !== null && _a !== void 0 ? _a : locale
  }))));
}